import { Story } from '../types/story';
import { lisbonNeighbor } from './stories/2025-12-01';
import { edinburghReunion } from './stories/2025-12-02';
import { budapestTranslator } from './stories/2025-12-03';
import { praguePhotographer } from './stories/2025-12-04';
import { amsterdamDomme } from './stories/2025-12-05';
import { dublinAffair } from './stories/2025-12-06';
import { lyonBookshop } from './stories/2025-12-07';
import { viennaDivorce } from './stories/2025-12-08';
import { berlinBackstage } from './stories/2025-12-09';
import { bratislavaHostel } from './stories/2025-12-10';
import { florenceMuseum } from './stories/2025-12-11';
import { parisTutor } from './stories/2025-12-12';
import { pragueJazzBand } from './stories/2025-12-13';
import { tokyoRopeStudio } from './stories/2025-12-14';
import { buenosAiresTango } from './stories/2025-12-15';
import { marrakechRiad } from './stories/2025-12-16';
import { milanApartment } from './stories/2025-12-17';
import { oxfordLibrary } from './stories/2025-12-18';
import { berlinUnderground } from './stories/2025-12-19';
import { lateSummerInParis } from './stories/2025-12-20';
import { amsterdamInBetween } from './stories/2025-12-21';
import { copenhagenWinter } from './stories/2025-12-22';
import { lisbonRooftop } from './stories/2025-12-23';
import { madridAfterMidnight } from './stories/2025-12-24';
import { biarritzWaves } from './stories/2025-12-25';
import { pragueLibrary } from './stories/2025-12-26';
import { viennaCoffeeHouse } from './stories/2025-12-27';
import { stockholmSauna } from './stories/2025-12-28';
import { dublinPub } from './stories/2025-12-29';
import { brusselsGallery } from './stories/2025-12-30';
import { barcelonaNewYear } from './stories/2025-12-31';
import { osloBathhouse } from './stories/2026-01-01';
import { berlinFirstTime } from './stories/2026-01-02';
import { istanbulCafe } from './stories/2026-01-03';
import { berlinLateNightTrain } from './stories/2026-01-04';
import { newYorkCall } from './stories/2026-01-05';
import { tokyoBookstore } from './stories/2026-01-06';
import { parisMetro } from './stories/2026-01-07';
import { barcelonaRooftop } from './stories/2026-01-08';
import { napoliBlood } from './stories/2026-01-09';
import { pragueManuscript } from './stories/2026-01-10';
import { florenceColumns } from './stories/2026-01-11';
import { amsterdamTriangle } from './stories/2026-01-12';
import { stockholmSyndrome } from './stories/2026-01-13';
import { parisDivorcees } from './stories/2026-01-14';
import { amsterdamRedLight } from './stories/2026-01-15';
import { londonNeighbor as londonNeighbor2 } from './stories/2026-01-16';
import { barcelonaPhotoWalk } from './stories/2026-01-17';
import { londonEyesWideShut1 } from './stories/2026-01-18';
import { londonEyesWideShut2 } from './stories/2026-01-19';
import { londonLoveTriangle } from './stories/2026-01-20';
import { oxfordSecretHistory } from './stories/2026-01-21';
import { viennaSymphony } from './stories/2026-01-22';
import { copenhagenMorning } from './stories/2026-01-23';
import { londonFootball1 } from './stories/2026-01-24';
import { londonFootball2 } from './stories/2026-01-25';
import { londonFootball3 } from './stories/2026-01-26';
import { londonMessy } from './stories/2026-01-27';
import { romeCooking } from './stories/2026-01-28';
import { edinburghBookshop } from './stories/2026-01-29';
import { viennaForum } from './stories/2026-01-30';
import { berlinDungeon } from './stories/2026-01-31';

// All stories in the system
const allStories: Story[] = [
  lisbonNeighbor,         // 2025-12-01
  edinburghReunion,       // 2025-12-02
  budapestTranslator,     // 2025-12-03
  praguePhotographer,     // 2025-12-04
  amsterdamDomme,         // 2025-12-05
  dublinAffair,           // 2025-12-06
  lyonBookshop,           // 2025-12-07
  viennaDivorce,          // 2025-12-08
  berlinBackstage,        // 2025-12-09
  bratislavaHostel,       // 2025-12-10
  florenceMuseum,         // 2025-12-11
  parisTutor,             // 2025-12-12
  pragueJazzBand,         // 2025-12-13
  tokyoRopeStudio,        // 2025-12-14
  buenosAiresTango,       // 2025-12-15
  marrakechRiad,          // 2025-12-16
  milanApartment,         // 2025-12-17
  oxfordLibrary,          // 2025-12-18
  berlinUnderground,      // 2025-12-19
  lateSummerInParis,      // 2025-12-20
  amsterdamInBetween,     // 2025-12-21
  copenhagenWinter,       // 2025-12-22
  lisbonRooftop,          // 2025-12-23
  madridAfterMidnight,    // 2025-12-24
  biarritzWaves,          // 2025-12-25
  pragueLibrary,          // 2025-12-26
  viennaCoffeeHouse,      // 2025-12-27
  stockholmSauna,         // 2025-12-28
  dublinPub,              // 2025-12-29
  brusselsGallery,        // 2025-12-30
  barcelonaNewYear,       // 2025-12-31
  osloBathhouse,          // 2026-01-01
  berlinFirstTime,        // 2026-01-02
  istanbulCafe,           // 2026-01-03
  berlinLateNightTrain,   // 2026-01-04
  newYorkCall,            // 2026-01-05
  tokyoBookstore,         // 2026-01-06
  parisMetro,             // 2026-01-07
  barcelonaRooftop,       // 2026-01-08
  napoliBlood,            // 2026-01-09
  pragueManuscript,       // 2026-01-10
  florenceColumns,        // 2026-01-11
  amsterdamTriangle,      // 2026-01-12
  stockholmSyndrome,      // 2026-01-13
  parisDivorcees,         // 2026-01-14
  amsterdamRedLight,      // 2026-01-15
  londonNeighbor2,        // 2026-01-16
  barcelonaPhotoWalk,     // 2026-01-17
  londonEyesWideShut1,    // 2026-01-18
  londonEyesWideShut2,    // 2026-01-19
  londonLoveTriangle,     // 2026-01-20
  oxfordSecretHistory,    // 2026-01-21
  viennaSymphony,         // 2026-01-22
  copenhagenMorning,      // 2026-01-23
  londonFootball1,        // 2026-01-24
  londonFootball2,        // 2026-01-25
  londonFootball3,        // 2026-01-26
  londonMessy,            // 2026-01-27
  romeCooking,            // 2026-01-28
  edinburghBookshop,      // 2026-01-29
  viennaForum,            // 2026-01-30
  berlinDungeon,          // 2026-01-31
];

/**
 * Get all published stories based on current date
 * Stories are automatically published when their publishDate is reached
 */
export const getPublishedStories = (): Story[] => {
  const today = new Date().toISOString().split('T')[0];
  return allStories
    .filter(story => story.publishDate <= today)
    .sort((a, b) => b.publishDate.localeCompare(a.publishDate)); // Most recent first
};

/**
 * Get a specific story by ID
 */
export const getStoryById = (id: string): Story | undefined => {
  return allStories.find(story => story.id === id);
};

/**
 * Get all stories (including unpublished - for admin use)
 */
export const getAllStories = (): Story[] => {
  return allStories;
};
